import { apiCallback } from 'api';

const definition = {
  service: 'content',
  endpoint: 'en',
  verbs: ['put'],
  query: {
    clientType: 'WEB_APP',
  },
  defaultVersion: 2,
};

export default {
  put: apiCallback(definition, 'put'),
};
